import { Fragment, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Button, Typography } from "@material-ui/core";
import cotizador from "../../services/cotizador";
import { AlertModal, SnackBar, Spinner } from "../../shared/components";
import useStyles from "./styles";
import GrupoPanel from "./grupoPanel";
import EndosoPanel from "./endosoPanel";

const AltaFlotillas = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [cargandoGrupo, setCargandoGrupo] = useState(true);
  const [grupo, setGrupo] = useState("");
  const [inicioVigencia, setInicioVigencia] = useState("");
  const [grupoInfo, setGrupoInfo] = useState({
    contratante: "",
    fechaInicio: "",
    fechaFin: "",
  });
  const [errorGrupo, setErrorGrupo] = useState("");
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [cotizacionData, setCotizacionData] = useState(null);
  const [solicitud, setSolicitud] = useState(null);
  const [productos, setProductos] = useState([]);
  const [cargandoProductos, setCargandoProductos] = useState(false);
  const [errorProductos, setErrorProductos] = useState(false);
  const [emitiendo, setEmitiendo] = useState(false);
  const [cancelando, setCancelando] = useState(false);
  const [modalExito, setModalExito] = useState(false);
  const [pasoTarifas, setPasoTarifas] = useState(false);
  const [noSolicitudRecuperada, setNoSolicitudRecuperada] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const grupoUrl = params.get("grupo");
    const inicioUrl = params.get("inicioVigencia");
    const noSolicitudUrl = params.get("noSolicitud");
    if (!grupoUrl) {
      history.push("/");
      return;
    }
    setGrupo(grupoUrl);
    setInicioVigencia(inicioUrl || "");
    setNoSolicitudRecuperada(noSolicitudUrl || "");
    const loadGrupo = async () => {
      const response = await cotizador.consultaGrupo(grupoUrl);
      if (response.data?.codigo === 1) {
        setGrupoInfo({
          contratante: response.data.client?.personalData?.businessName || "",
          fechaInicio: response.data.fechaInicio,
          fechaFin: response.data.fechafinal,
        });
        setErrorGrupo("");
      } else {
        setErrorGrupo(
          "No se encontró información para el grupo ingresado, verifica que el número sea correcto."
        );
      }
      setCargandoGrupo(false);
    };
    loadGrupo();
    if (noSolicitudUrl) cargarCotizacionRecuperada(noSolicitudUrl);
    // eslint-disable-next-line
  }, []);

  const handleCancelar = async () => {
    if (cancelando) return;
    const noSolicitud = solicitud || noSolicitudRecuperada;
    if (!noSolicitud) {
      history.push("/");
      return;
    }
    setCancelando(true);
    const res = await cotizador.cancelaSoflosub({
      noSolicitud: Number(noSolicitud),
    });
    if (!res.data) {
      setMessage({
        text:
          res.error?.mensaje ||
          "No fue posible cancelar la solicitud. Intenta nuevamente.",
        severity: "error",
      });
      setShowMessage(true);
      setCancelando(false);
      return;
    }
    history.push("/");
  };

  const handleVolverInicio = () => {
    history.push("/");
  };

  const cargarProductos = async (noSolicitud) => {
    setCargandoProductos(true);
    setErrorProductos(false);
    const res = await cotizador.getGroupFleetProducts({
      requestNumber: Number(noSolicitud),
    });
    if (res.data) setProductos(res.data);
    else {
      setErrorProductos(true);
      if (res.error?.mensaje) {
        setMessage({
          text: res.error.mensaje,
          severity: "error",
        });
        setShowMessage(true);
      }
    }
    setCargandoProductos(false);
  };

  const cargarCotizacionRecuperada = async (noSolicitud) => {
    const res = await cotizador.getFleetQuoteDetail({
      requestNumber: Number(noSolicitud),
    });
    if (!res.data?.data) return;
    setCotizacionData(res.data.data);
    setSolicitud(noSolicitud);
    cargarProductos(noSolicitud);
  };

  const handleCotizado = (data, noSolicitud) => {
    setCotizacionData(data);
    setSolicitud(noSolicitud);
    setPasoTarifas(false);
    cargarProductos(noSolicitud);
  };

  const handleEmitir = async (selections) => {
    if (!solicitud) return;
    setEmitiendo(true);
    const payload = {
      requestNumber: Number(solicitud),
      subgroupInfo: selections.subgroupInfo,
    };
    const response = await cotizador.emitFleet(payload);
    if (!response.data) {
      setMessage({
        text:
          response.error?.mensaje ||
          "No fue posible completar la emisión. Intenta nuevamente.",
        severity: "error",
      });
      setShowMessage(true);
      setEmitiendo(false);
      return;
    }
    const { successCount, failureCount, results } = response.data.data || {};
    const exitosas = successCount ?? 0;
    const fallidas = failureCount ?? 0;
    if (fallidas === 0) {
      setMessage({
        text:
          response.data?.mensaje ||
          "La emisión ha sido confirmada de manera satisfactoria. Has sido copiado en el correo que hemos enviado al contratante del grupo con la documentación correspondiente al endoso realizado",
        severity: "success",
      });
      setEmitiendo(false);
      setModalExito(true);
    } else if (exitosas > 0) {
      const detalle = results
        ?.filter((r) => !r.success)
        .map((r) => r.errorMessage)
        .filter(Boolean);
      console.error("Emisión parcial (HU3):", detalle);
      setMessage({
        text: `La emisión se completó parcialmente: ${exitosas} de ${
          exitosas + fallidas
        } unidades emitidas.`,
        severity: "warning",
      });
      setShowMessage(true);
      setEmitiendo(false);
    } else {
      const detalle = results
        ?.filter((r) => !r.success)
        .map((r) => r.errorMessage)
        .filter(Boolean);
      console.error("Emisión fallida (HU3):", detalle);
      setMessage({
        text: "No fue posible completar la emisión. Intenta nuevamente.",
        severity: "error",
      });
      setShowMessage(true);
      setEmitiendo(false);
    }
  };

  if (cargandoGrupo) return <Spinner />;

  if (errorGrupo) {
    return (
      <div className={classes.root}>
        <div className={classes.errorBox}>
          <p>{errorGrupo}</p>
          <Button
            variant="contained"
            className={classes.button}
            onClick={handleVolverInicio}
          >
            Volver al inicio
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Fragment>
      <SnackBar
        HandleShow={setShowMessage}
        show={showMessage}
        severity={message.severity}
        text={message.text}
        time={message.time ?? 15000}
        action={message.action}
      />
      <div className={classes.root}>
        <div className={classes.panelIzquierdo}>
          <GrupoPanel
            grupo={grupo}
            inicioVigencia={inicioVigencia}
            grupoInfo={grupoInfo}
          />
        </div>
        <div className={classes.panelDerecho}>
          <Typography variant="h5" className={classes.tituloDerecho}>
            Alta de flotillas
          </Typography>
          <EndosoPanel
            grupo={grupo}
            grupoInfo={grupoInfo}
            inicioVigencia={inicioVigencia}
            onCancelar={handleCancelar}
            cancelando={cancelando}
            onSolicitudCreada={setSolicitud}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
            onCotizado={handleCotizado}
            cotizacionData={cotizacionData}
            productos={productos}
            cargandoProductos={cargandoProductos}
            errorProductos={errorProductos}
            onReintentarProductos={() => cargarProductos(solicitud)}
            onEmitir={handleEmitir}
            emitiendo={emitiendo}
            pasoTarifas={pasoTarifas}
            onContinuar={() => setPasoTarifas(true)}
            noSolicitudRecuperada={noSolicitudRecuperada || undefined}
          />
        </div>
      </div>
      <AlertModal
        open={modalExito}
        close={() => {
          setModalExito(false);
          history.push("/");
        }}
        SuccessText="Continuar"
        message={message.text}
        title="Atención"
        success={() => {
          setModalExito(false);
          history.push("/");
        }}
        type={2}
      />
    </Fragment>
  );
};

export default AltaFlotillas;
